import { B2bLandingPageWebComponent } from "./component/B2bLandingPageWebComponent";

export { B2bLandingPageWebComponent }
